module.exports = __webpack_public_path__ + "assets/img/title-a71f6ae7.png";